module.exports = "/_next/static/images/UnifyCustomerProfile-e69b0340b8d09feab428ade25cb88f24.webp";